import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Alert, CircularProgress } from "@mui/material";
import axios from "axios";
import { useTranslation } from 'react-i18next';

export default function SecuritySettingsPage({ currentUser }) {
  const { t } = useTranslation();
  const [jwtExpiry, setJwtExpiry] = useState(60);
  const [newExpiry, setNewExpiry] = useState(60);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    setLoading(true);
    axios.get("/api/config/jwt-expiry")
      .then(res => {
        setJwtExpiry(res.data.jwt_expiry_minutes);
        setNewExpiry(res.data.jwt_expiry_minutes);
        setLoading(false);
      })
      .catch(() => {
        setError(t('security.errors.jwtConfig'));
        setLoading(false);
      });
  }, []);

  const handleSave = () => {
    //const apiKey = localStorage.getItem("apiKey") || localStorage.getItem("API_KEY") || "your_frontend_api_key";
    //const apiSecret = localStorage.getItem("apiSecret") || localStorage.getItem("API_SECRET") || "your_frontend_api_secret";
    const apiKey = process.env.REACT_APP_API_KEY;
    const apiSecret = process.env.REACT_APP_API_SECRET;
    setSaving(true);
    setError("");
    setSuccess("");
    axios.post("/api/config/jwt-expiry", { jwt_expiry_minutes: newExpiry }, {
      headers: {
        "x-api-key": apiKey,
        "x-api-secret": apiSecret
      }
    })
      .then(res => {
        setJwtExpiry(res.data.jwt_expiry_minutes);
        setSuccess(t('security.success.jwtUpdated'));
      })
      .catch(() => {
        setError(t('security.errors.jwtSave'));
      })
      .finally(() => setSaving(false));
  };

  const handleClick = () => {
    // Il semble qu'il n'y ait pas de fonction handleClick définie dans votre code.
    // Vous devrez définir cette fonction pour gérer le clic sur le CardActionArea.
  };

  return (
    <Box sx={{ p: 3, maxWidth: 500 }}>
      <Typography variant="h5" gutterBottom>{t('security.jwt.title')}</Typography>
      {loading ? <CircularProgress /> : (
        <>
          <Typography variant="body1" gutterBottom>{t('security.jwt.description')} : <b>{jwtExpiry} minutes</b></Typography>
          <TextField
            label={t('security.jwt.durationLabel')}
            type="number"
            value={newExpiry}
            onChange={e => setNewExpiry(Number(e.target.value))}
            fullWidth
            sx={{ mb: 2 }}
            inputProps={{ min: 1, max: 1440 }}
          />
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSave} 
            disabled={saving}
          >
            {saving ? <CircularProgress size={24} /> : t('common.save')}
          </Button>
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
        </>
      )}
    </Box>
  );
}
